const CONTEXT_LAYER_URL = '/store-header-module/services/contextlayer';
export function fetchStoresAroundRenderingService(storeSearchData, successCallback, errorCallback, completeCallback) {
  lm.fetch({
    url: CONTEXT_LAYER_URL + '/store-search-result',
    data: storeSearchData,
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Accept': 'text/html',
      'Content-Type': 'text/html; charset=UTF-8',
      'Cache': 'no-cache',
      'Access-Control-Allow-Origin': '*'
    },
    success: successCallback,
    error: errorCallback,
    complete: completeCallback
  });
}